export default __webpack_public_path__ + "static/media/nelonen_logo_slogan.b62f1b4b.svg";